import React, { useEffect, useState } from "react";
import { Button, Tag } from "antd";
import {
  AppstoreOutlined,
  CloudSyncOutlined,
  DatabaseOutlined,
  DownloadOutlined,
  MessageOutlined,
  SearchOutlined,
  ThunderboltOutlined,
  WindowsOutlined,
} from "@ant-design/icons";
import "./homeLanding.css";
type Latest = { url: string; version: string; size: number };
const Home_item1_UI = () => {
  const [latest, setLatest] = useState<Latest>({
      url: "",
      version: "",
      size: 0,
    }),
    [loading, setLoading] = useState(true);
  useEffect(() => {
    document.title = "ChatTool · 智能话术工作台";
    fetch("https://chatv2.leytcn.com/api/app_update/latest.php")
      .then((r) => r.json())
      .then((r) => r.message === 2000 && setLatest(r.info))
      .finally(() => setLoading(false));
  }, []);
  const features = [
    {
      icon: <SearchOutlined />,
      title: "秒级找到话术",
      desc: "通过关键词、分类和快捷键，快速定位适合当前场景的回复。",
    },
    {
      icon: <DatabaseOutlined />,
      title: "结构化知识库",
      desc: "按商品、业务和问题类型组织话术，让内容长期可维护。",
    },
    {
      icon: <ThunderboltOutlined />,
      title: "快捷调用",
      desc: "减少重复输入和页面切换，将更多时间留给服务本身。",
    },
    {
      icon: <CloudSyncOutlined />,
      title: "团队持续迭代",
      desc: "统一更新高质量回复，让有效经验快速成为团队知识。",
    },
  ];
  return (
    <div className="chat-landing-v2 landing-v2">
      <section className="chat-v2-hero">
        <div className="chat-v2-hero-grid">
          <div className="chat-v2-copy">
            <Tag color="purple">SMART REPLY WORKSPACE</Tag>
            <h1>
              让每一次回复
              <br />
              <em>更快、更准、更一致</em>
            </h1>
            <p>
              为客服和运营团队打造的智能话术工作台，集中管理、快速搜索并高效调用专业回复。
            </p>
            <div id="download" className="chat-v2-actions">
              <Button
                type="primary"
                size="large"
                loading={loading}
                disabled={!latest.url}
                icon={<WindowsOutlined />}
                href={latest.url || undefined}
              >
                下载 Windows 客户端
              </Button>
              <Button size="large" ghost href="/login">
                进入工作台
              </Button>
            </div>
            <small className="chat-v2-version">
              {latest.version
                ? `v${latest.version} · ${latest.size ? (latest.size / 1048576).toFixed(1) + " MB · " : ""}Windows x64`
                : "正在查询最新版本"}
            </small>
          </div>
          <div className="chat-v2-preview">
            <div className="preview-bar">
              <span>
                <i></i>
                <i></i>
                <i></i>
              </span>
              <small>REPLY LIBRARY</small>
            </div>
            <div className="preview-search">
              <SearchOutlined />
              搜索话术、商品或问题...
            </div>
            <div className="preview-layout">
              <aside>
                <b>常用分类</b>
                {["售前咨询", "订单问题", "物流进度", "售后处理"].map((x) => (
                  <span key={x}>{x}</span>
                ))}
              </aside>
              <main>
                <Tag color="purple">推荐回复</Tag>
                <h3>商品发货时间说明</h3>
                <p>
                  您好，订单将按照付款顺序尽快安排发出，发货后可在订单页查看物流信息。
                </p>
                <Button type="primary">复制话术</Button>
              </main>
            </div>
          </div>
        </div>
      </section>
      <section className="chat-v2-stats">
        <span>
          <b>1 处</b>
          <small>集中管理</small>
        </span>
        <span>
          <b>&lt; 1s</b>
          <small>话术检索</small>
        </span>
        <span>
          <b>24/7</b>
          <small>知识可用</small>
        </span>
        <span>
          <b>Windows</b>
          <small>桌面客户端</small>
        </span>
      </section>
      <section id="features" className="chat-v2-section">
        <div className="chat-v2-heading">
          <small>WHY CHATTOOL</small>
          <h2>把团队经验，变成随时可用的回复能力</h2>
          <p>从内容沉淀到一线使用，减少重复工作。</p>
        </div>
        <div className="chat-v2-features">
          {features.map((x) => (
            <article key={x.title}>
              <i>{x.icon}</i>
              <h3>{x.title}</h3>
              <p>{x.desc}</p>
            </article>
          ))}
        </div>
      </section>
      <section id="workflow" className="chat-v2-flow">
        <div>
          <small>ONE SIMPLE FLOW</small>
          <h2>建立、搜索、使用，然后持续优化</h2>
        </div>
        {[
          "管理员建立结构化话术库",
          "团队成员按场景快速搜索",
          "收集有效回复并持续迭代",
        ].map((x, i) => (
          <span key={x}>
            <b>0{i + 1}</b>
            {x}
          </span>
        ))}
      </section>
      <section className="chat-v2-download">
        <MessageOutlined />
        <div>
          <small>START NOW</small>
          <h2>让专业回复成为团队标准</h2>
          <p>下载桌面客户端，开始更高效的话术管理。</p>
        </div>
        <Button
          type="primary"
          size="large"
          loading={loading}
          disabled={!latest.url}
          icon={<DownloadOutlined />}
          href={latest.url || undefined}
        >
          下载{latest.version ? ` v${latest.version}` : ""}
        </Button>
      </section>
      <footer className="chat-v2-footer landing-footer">
        <b>聊天助手</b>
        <span>智能话术与团队知识工作台</span>
        <a href="/login">进入工作台</a>
      </footer>
    </div>
  );
};
export default Home_item1_UI;
